
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

export default {
name:'download',
components:{
XButton,
Icon
},
methods:{
cancel(){
this.$emit('on-cancel');
},
download(){
const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; 
window.location.href = isAndroid ? 'http://sj.qq.com/myapp/detail.htm?apkName=com.lvxiang.risingvideo' : 'https://itunes.apple.com/cn/app/id1384495302'
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/Download.vue